<template>
  <div class="rows-list">
    <div
      v-for="(item, index) in data"
      :key="`rows-list-${index}-${Math.random()}`"
      :class="`rows-list__item rows-list__item__index-${index}`"
    >
      <row-standard
        :access-type="accessType"
        :index="index"
        :value="item"
        v-on="$listeners"
      />
    </div>
  </div>
</template>

<script>
import RowStandard from './RowStandard.vue';

export default {
  components: {
    RowStandard,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    accessType: {
      type: String,
      default: () => 'NoAccess',
    },
  },
};
</script>
